import {Component} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {NavbarComponent} from './core/components/navbar/navbar.component';
import {FooterComponent} from './core/components/footer/footer.component';

@Component({
    selector: 'wci-root',
    imports: [RouterOutlet, NavbarComponent, FooterComponent],
    template: `
        <div class="container px-2 sm:px-6">
            <wci-navbar class="sticky top-0 z-50"></wci-navbar>

            <router-outlet></router-outlet>

            <wci-footer></wci-footer>
        </div>
    `,
    styles: [],
})
export class AppComponent {}
